import {useEffect, useReducer} from "react";

let cache = {};

const reducer = (state, action) => {
    switch (action.type) {
        case 'setData':
            return action.payload;
        case 'addToMyProgram':
            const addedToProgramState = {
                ...state,
                reports: {
                    ...state.reports,
                    [action.id]: {
                        ...state.reports[action.id],
                        isUserSelected: true,
                    }
                }
            };
            cache[action.conferenceId] = addedToProgramState;

            return addedToProgramState;
        case 'removeFromMyProgram':
            const removedFromProgramState = {
                ...state,
                reports: {
                    ...state.reports,
                    [action.id]: {
                        ...state.reports[action.id],
                        isUserSelected: false,
                    }
                }
            }
            cache[action.conferenceId] = removedFromProgramState;

            return removedFromProgramState;
        default:
            throw new Error();
    }
}

const processResult = (id, result) => {
    const reports = {};
    const authors = {};
    Object.values(result).forEach(section => {
        Object.values(section).forEach(sectionElement => {
            const reportElements = Object.values(sectionElement.elements);

            if (reportElements.length) {
                reportElements.forEach(element => {
                    if (element.conferenceReport) {
                        reports[element.conferenceReport.id] = element.conferenceReport;
                        reports[element.conferenceReport.id].isUserSelected = element.isUserSelected;
                        reports[element.conferenceReport.id].elementId = element.id;
                        reports[element.conferenceReport.id].section = sectionElement;

                        if (element.conferenceReport.authors.length) {
                            element.conferenceReport.authors.forEach(author => {
                                if (authors[author.id] !== undefined) {
                                    authors[author.id].reportCount += 1;
                                } else {
                                    authors[author.id] = author;
                                    authors[author.id].reportCount = 1;
                                }

                                if (authors[author.id].sections && authors[author.id].sections[sectionElement.id]) {
                                    authors[author.id].sections[sectionElement.id].elements[element.conferenceReport.id] = element;
                                } else {
                                    authors[author.id].sections = {
                                        [sectionElement.id]: {
                                            ...sectionElement,
                                            elements: {
                                                [element.conferenceReport.id]: element
                                            }
                                        }
                                    }
                                }
                            })
                        }
                    }
                });
            }
        });
    })

    return {
        program: result,
        reports: reports,
        authors: authors,
    };
}

export const updateReportStatus = (id, elementId, reportId, dispatch, method) => {
    return fetch(`/api/v1/conferences/${id}/elements/${elementId}`, {
        method: method,
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
    })
        .then(res => res.json())
        .then(() => {
            const type = method === 'POST' ? 'addToMyProgram' : 'removeFromMyProgram';
            dispatch({type: type, id: reportId, conferenceId: id});
        });
}

export default function useEventProgram(id) {
    const [programData, dispatch] = useReducer(reducer, cache[id]);

    useEffect(() => {
        if (!cache[id]) {
            fetch('/api/v1/conference/' + id + '/program')
                .then(res => res.json())
                .then(
                    (result) => {
                        const data = processResult(id, result);
                        cache[id] = data;

                        dispatch({
                            type: 'setData',
                            payload: data,
                        })
                    }
                )
        }
    }, [id]);

    return [programData, dispatch];
}
